"use client";

var _excluded = ["onExpand", "onCollapse", "onBeforeExpand", "onBeforeCollapse", "expanded", "className", "children"];

var _templateObject;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useEffect, useState } from "react";
import { Collapse } from "react-collapse";
import { createGlobalStyle } from "styled-components";
var collapseClassName = "MeshExpander--collapse";
var quarticEaseOut = "cubic-bezier(.17, .84, .44, 1)";
var CollapseStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .", " {\n    transition: height 300ms;\n    transition-timing-function: ", ";\n  }\n"])), collapseClassName, quarticEaseOut);

function useExpanderLifecycle(_ref) {
  var expanded = _ref.expanded,
      onExpand = _ref.onExpand,
      onCollapse = _ref.onCollapse,
      onBeforeExpand = _ref.onBeforeExpand,
      onBeforeCollapse = _ref.onBeforeCollapse;

  var _useState = useState(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      prevExpanded = _useState2[0],
      setPrevExpanded = _useState2[1];

  if (expanded && !prevExpanded) {
    onBeforeExpand === null || onBeforeExpand === void 0 ? void 0 : onBeforeExpand();
    setPrevExpanded(expanded);
  }

  if (!expanded && prevExpanded) {
    onBeforeCollapse === null || onBeforeCollapse === void 0 ? void 0 : onBeforeCollapse();
    setPrevExpanded(expanded);
  }

  useEffect(function () {
    expanded ? onExpand === null || onExpand === void 0 ? void 0 : onExpand() : onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse();
  }, [expanded]);
}

var Expander = function Expander(_ref2) {
  var onExpand = _ref2.onExpand,
      onCollapse = _ref2.onCollapse,
      onBeforeExpand = _ref2.onBeforeExpand,
      onBeforeCollapse = _ref2.onBeforeCollapse,
      _ref2$expanded = _ref2.expanded,
      expanded = _ref2$expanded === void 0 ? false : _ref2$expanded,
      className = _ref2.className,
      children = _ref2.children,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  var _useState3 = useState(!expanded),
      _useState4 = _slicedToArray(_useState3, 2),
      shouldHideChildren = _useState4[0],
      setHideChildren = _useState4[1];

  function handleRest() {
    if (!expanded) {
      setHideChildren(true);
    }
  }

  useExpanderLifecycle({
    onExpand: onExpand,
    onCollapse: onCollapse,
    onBeforeExpand: onBeforeExpand,
    onBeforeCollapse: onBeforeCollapse,
    expanded: expanded
  });
  useEffect(function () {
    if (expanded) {
      setHideChildren(false);
    }
  }, [expanded]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CollapseStyle, null), /*#__PURE__*/React.createElement("div", {
    hidden: !expanded && shouldHideChildren
  }, /*#__PURE__*/React.createElement(Collapse, _extends({}, otherProps, {
    theme: {
      collapse: collapseClassName
    },
    isOpened: expanded,
    "aria-hidden": !expanded,
    onRest: handleRest,
    className: className
  }), children)));
};

export default Expander;